import { Point } from './types'

import Delaunator from 'delaunator'

export const getCentroid = (points: Point[]): Point => {
  return {
    x: (points[0].x + points[1].x + points[2].x) / 3,
    y: (points[0].y + points[1].y + points[2].y) / 3
  }
}

const triangleOfEdge = (e: number): number => {
  // from https://mapbox.github.io/delaunator/#edge-and-triangle
  return Math.floor(e / 3)
}

export const nextHalfedge = (e: number): number => {
  // from https://mapbox.github.io/delaunator/#edge-and-triangle
  return e % 3 === 2 ? e - 2 : e + 1
}

export const getPointsOfTriangle = (
  triangleIndex: number,
  points: Point[],
  delaunay: Delaunator<unknown>
): Point[] => {
  const firstIndexOfTriangle = triangleIndex - (triangleIndex % 3)
  return [
    points[delaunay.triangles[firstIndexOfTriangle]],
    points[delaunay.triangles[firstIndexOfTriangle + 1]],
    points[delaunay.triangles[firstIndexOfTriangle + 2]]
  ]
}

export const forEachTriangleEdge = (
  points: Point[],
  delaunay: Delaunator<unknown>,
  callback: (e: number, p: Point, q: Point) => void
) => {
  // from https://mapbox.github.io/delaunator/#edge-and-triangle
  for (let e = 0; e < delaunay.triangles.length; e++) {
    if (e > delaunay.halfedges[e]) {
      const p = points[delaunay.triangles[e]]
      const q = points[delaunay.triangles[nextHalfedge(e)]]
      callback(e, p, q)
    }
  }
}
